import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from '@mui/material';


// import { ClassNames } from '@emotion/react';

const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    <Box>
      <Box marginBottom={2}>
        <Typography fontWeight={700} variant={'h5'}>
          {tittle}
        </Typography>
      </Box>
      <Box>
        {items.map((item, i) => (
          <Box
            component={Accordion}
            key={i}
            padding={1}
            marginBottom={i === item.length - 1 ? 0 : 2}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={`panel1a-header--${i}`}
            >
              <Typography fontWeight={1000}>{item.tittle}</Typography>
            </Box>
            <AccordionDetails>
              {item.subtittle}
            </AccordionDetails>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Download = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            {
              tittle: '1. What is the procedure for admission?',
              subtittle:
                  <table>
                    <thead >
                    <tr>
                      <>
                        <td><strong>A. Submission of Application</strong></td>
                      </>
                    </tr>
                    

                    <tr>
                      <td>✓ Visit our website  https://www.npsypr.edu.in</td>
                    </tr>
                    <tr>
                      <td>✓ Click on the Online Application button in the Menu Bar.</td>
                    </tr>
                    <tr>
                      <td>✓ Enter the registered email address.</td>
                    </tr>

                    <tr>
                      <td>✓ Submit the OTP.</td>
                    </tr>
                    <tr>
                      <td>✓ Update and submit the requested information. Grade 2 and above please ensure to update the report cards for the past 3 years.</td>
                    </tr>
                    <tr>
                      <td>✓ Further communication regarding Interaction / Entrance Test will be mailed from admissions@npsypr.edu.in.</td>
                    </tr>
                    <tr>
                      <>
                        <td>Kindly note : Incomplete applications will not be considered.</td>
                      </>
                    </tr>
                    
                    <tr >
                      <>
                        <td>B. Interaction Process</td>
                      </>
                    </tr>
                    <tr>
                      <>
                        <td><strong>Pre-primary</strong></td>
                      </>
                    </tr>
                    <tr>
                      <td>✓ Pre-primary applicants will be called for interaction.</td>
                    </tr>
                    <tr>
                      <td>✓ Selected applicant will receive a confirmation email from admissions@npsypr.edu.in</td>
                    </tr>
                    
                    <tr>
                      <>
                        <td><strong>Grade 1 and above</strong></td>
                      </>
                    </tr>
                    <tr>
                      <td>✓ Applicants will be invited in batches for Entrance Test. All details will be emailed to the parent’s email ID.</td>
                    </tr>
                    <tr>
                      <td>✓ List of selected candidates for interaction will be put up on the website.</td>
                    </tr>
                    <tr>
                      <td>✓ Date of interaction for the selected candidates will be mailed.</td>
                    </tr>
                    <tr>
                      <td>✓ List of selected candidates for admission will be put up on the website.</td>
                    </tr>
                    </thead>
                  </table>
            },
            {
              tittle: '2. What are the various streams of Pre-Primary courses of NPS YPR?',
              subtittle:
              <table>
                <thead>
                <>
                  <tr>
                    <td>There are two streams of Pre-Primary courses which run parallel :</td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td>✓Montessori</td>
                  </tr>
                  <tr>
                    <td>✓Kindergarten</td>
                  </tr>
               
                </>
                </thead>
              
              </table>
            },
            {
              tittle: '3. What is Montessori Method of Teaching?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Montessori is a method of education that is based on self-directed activity and hands-on learning developed by Dr Maria Montessori. Every material in our Montessori classroom supports an aspect of child development, creating a match between the child’s natural interest and the designed curriculum. Subjects such as Exercises of Practical Life, Sensorial, Language and Arithmetic are taught with scientifically designed materials which are age appropriate.<Link href='/montessori'> Know more </Link></td>
                  </>
                </tr>
                </thead>
              </table>
            },
            {
              tittle: '4. How many years in the Montessori programmme?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Montessori programme is a three year programme (Montessori I, Montessori II, Montessori III) after which students are promoted Class I.</td>
                  </>
                </tr>
                </thead>
              </table>
            },
            {
              tittle: '5. What would be the age limit for admission to Montessori - I?',
              subtittle:
              <table>
                <thead>
                <>
                  <tr>
                    <td><strong>Age Limit of the child for admission as on 1 June:</strong></td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td>•	Montessori-I : 3 years and above</td>
                  </tr>
                  <tr>
                    <td>•	Montessori-II : 4 years and above </td>
                  </tr>
                  <tr>
                    <td>•	Montessori-III : 5 years and above </td>
                  </tr>
                  <tr>
                    <td>•	Class 1 should have completed 6 years  </td>
                  </tr>
                </>
                </thead>
            
              </table>
            },
            {
              tittle: '6 .What is Kindergarten programme?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Education techniques in Kindergarten are customised to suit the needs of children. The best of various educational approaches like Waldorf education, Reggio Emilia approach, Glenn Doman technique and other techniques are adapted to enhance the capabilities of children. <Link  href='/kindergarten'>Know more. </Link></td>
                  </>
                </tr>
                </thead>
              </table>

            },
            {
              tittle: '7. How many years is the Kindergarten programme?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Kindergarten programme is a three-year programme (Pre-K, KG-I, KG-II) after which students go to Class I.</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            {
              tittle: '8. What would be the age limit for the admission to Kindergarten?',
              subtittle:
              <table>
                <thead>
                <>
                  <tr>
                    <td><strong>Age Limit of the child for admission as on 1 June:</strong></td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td>•	Pre-K : 3 years and above</td>
                  </tr>
                  <tr>
                    <td>•	Kindergarten I : 4 years and above</td>
                  </tr>
                  <tr>
                    <td>•	Kindergarten II : 5 years and above </td>
                  </tr>
                  <tr>
                    <td>•	Class 1 should have completed 6 years </td>
                  </tr>
                </>
                </thead>
              </table>
            },
            {
              tittle: '9. What is the duration of the written test?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Each paper is designed for 45 minutes.
                    </td>
                  </>
                </tr>
                <tr>
                  <>
                    <td>
                   Detailed instructions will be emailed to the applicant. 
                    </td>
                  </>
                </tr>
                <tr>
                  <>
                    <td>Kindly check the <Link href='/entrance-test-details'> `Entrance Test Details` </Link> under the link `Admission` in the website for details.</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            {
              tittle: '10. What is the duration of the Academic Year?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>The academic calendar is from June to March.</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            {
              tittle: '11. What are the timings of the school?',
              subtittle:
              <table>
                <thead>
                
                  <tr>
                    <td>Montessori I & Pre-K   :	 Monday to Friday -  09:30 a.m to 1:00 p.m</td>
                  </tr>
                  
                  {/* <br></br> */}
                  <tr>
                    <td>Montessori II and III   :	 Monday to Friday - 08:15 a.m to 1.00 p.m</td>
                  </tr>
                  {/* <br></br> */}
                  
                  <tr>
                    <td>KG - I & KG - II	:	Monday to Friday -	08:15 am to 1.00 pm</td>
                  </tr>
                  {/* <br></br> */}
                
                  <tr>
                    <td>STD I - XII	:	Monday to Friday - 08:15 am to 02:55 pm</td>
                  </tr>
                  {/* <br></br> */}
                  
                  <tr>
                    <td>Saturday for class 6 - 12	:	08:15 a.m to 12:00 noon</td>
                  </tr>
                  {/* <br></br> */}
                 
                  <tr>
                    <th>[Note: Full day timings for Montessori - III and Kindergarten II to be followed as per circulars which will be given from time to time.]</th>
                  </tr>
                
                </thead>
              </table>
            },
            {
              tittle: '12. When are the Co-Scholastic and Extra Curricular Activities conducted?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Co-Scholastic Activities are included in the regular time table. The Extra Curricular Activities are conducted after school hours.</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            {
              tittle: '13. How many students are there in a class?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>Each class would have an average of 30 - 32 students.</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            // {
            //   tittle: '14. Will the notebooks and textbooks be provided by the school?',
            //   subtittle:
            //   <table>
            //     <thead>
            //     <tr>
            //       <>
            //         <td>Yes, books are distributed by the school. Before the reopening of the school, details of the book issue will be notified on the School notice board, the website and parent app.</td>
            //       </>
            //     </tr>
            //     </thead>
            //   </table>

            // },
            // {
            //   tittle: 'How should the notebooks and textbooks be covered?',
            //   subtittle:
            //       <table>
            //         <thead>
            //         <tr>
            //           <>
            //             <th>For Classes - Montessori II, Montessori III, KG I, KG II, Classes 1 and 2:</th>
            //           </>
            //         </tr>
            //         {/* <br></br> */}

            //         <tr>
            //           <td>✓ Notebooks need not be covered.</td>
            //         </tr>
            //         <tr>
            //           <td>✓ Textbooks must be covered with plain brown sheet.</td>
            //         </tr>
            //         <tr>
            //           <td>✓ Stick labels on the top right hand corner of the textbook.</td>
            //         </tr>

            //         <tr>
            //           <td>✓ Mention the name of the child and class on the label. The section and the subject will be entered later.</td>
            //         </tr>
            //         <tr>
            //           <td>✓ Refrain from using fancy labels.</td>
            //         </tr>
            //         {/* <br></br> */}
            //         <tr>
            //           <>
            //             <th>For Classes - 3 to 12:</th>
            //           </>
            //         </tr>
            //         {/* <br></br> */}
            //         <tr>
            //           <>
            //             <td>✓ Notebooks need not to be covered.</td>
            //           </>
            //         </tr>
            //         <tr>
            //           <>
            //             <td>✓ Textbooks must be covered with plain brown sheet.</td>
            //           </>
            //         </tr>
            //         </thead>
            //       </table>
            // },
         
            {
              tittle: '14. When does my child wear House uniform and School uniform?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>House uniform on every Friday. Regular school uniform on other working days.</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            // {
            //   tittle: 'How should the notebooks and textbooks be covered?',
            //   subtittle:
            //       <table>
            //         <thead>
            //         <tr>
            //           <>
            //             <th>For Classes - Montessori II, Montessori III, KG I, KG II, Classes 1 and 2:</th>
            //           </>
            //         </tr>
            //         {/* <br></br> */}

            //         <tr>
            //           <td>✓ Notebooks need not be covered.</td>
            //         </tr>
            //         <tr>
            //           <td>✓ Textbooks must be covered with plain brown sheet.</td>
            //         </tr>
            //         <tr>
            //           <td>✓ Stick labels on the top right hand corner of the textbook.</td>
            //         </tr>

            //         <tr>
            //           <td>✓ Mention the name of the child and class on the label. The section and the subject will be entered later.</td>
            //         </tr>
            //         <tr>
            //           <td>✓ Refrain from using fancy labels.</td>
            //         </tr>
            //         {/* <br></br> */}
            //         <tr>
            //           <>
            //             <th>For Classes - 3 to 12:</th>
            //           </>
            //         </tr>
                   
            //         <tr>
            //           <>
            //             <td>✓ Notebooks need not to be covered.</td>
            //           </>
            //         </tr>
            //         <tr>
            //           <>
            //             <td>✓ Textbooks must be covered with plain brown sheet.</td>
            //           </>
            //         </tr>
            //         </thead>
            //       </table>
            // },
            {
              tittle: '15. What type of shoes have to be bought for my child?',
              subtittle:
              <table>
                <thead >
                <>
                  <tr>
                    <td><strong>Shoes for Montessori :</strong></td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td>Students are required to wear appropriate footwear and socks which are comfortable and easy for the children to use and help themselves.</td>
                  </tr>
                  <tr>
                  
                    <td><strong>Montessori :</strong></td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td>White Velcro Bata BFirst Shoes</td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td><strong>Kindergarten</strong></td>
                  </tr>

                  <tr>
                    <td>Black Velcro Bata BFirst Shoes</td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td><strong>Classes 1 - 6 :</strong></td>
                  </tr>
                  {/* <br></br> */}
                  <tr>
                    <td> Black with While Velcro Power Bata Shoes</td>
                  </tr>
                   <tr>
                    <td><strong>Classes 7 - 12 :</strong></td>
                  </tr>
                  <tr>
                    <td> Black and White Power Bata Shoes with lace</td>
                  </tr>
                </>
                </thead>
              </table>
            },
            {
              tittle: '16. When does my child wear white shoes?',
              subtittle:
              <table>
                <thead>
                <tr>
                  <>
                    <td>On every Friday and the days when students have Physical Education/sports. (Refer Timetable)</td>
                  </>
                </tr>
                </thead>
              </table>

            },
            {
              tittle: '17. Does the school provide transportation?',
              subtittle:
              <table>
                <thead>
                <>
                  <tr>
                    <td>Yes, School Transport has been outsourced to  ‘Sam Tours Travels’. Contact Details - 080 26699977/9513836577/8884916757</td>
                  </tr>
                  
                  
                </>
                </thead>
              </table>

            },
             {
               tittle: '18. Do you have a daycare program ?',
               subtittle: (
              <table>
              <thead>
              <tr>
              <td>
                  Yes we do.{" "}


                  
              <a
              href="https://npsypr-website.blr1.cdn.digitaloceanspaces.com/static-assets/current/home/home-static/static-images/all-static-images/pdf/daycare.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
            >
              more details
            </a>
          </td>
        </tr>
      </thead>
    </table>
  ),
}

           
          ]}
        />
      </Box>
      
      <Typography variant='h6' >For any related question <a href='/enquiry' style={{ textDecoration: 'none'}}>post them here</a>

    </Typography>
      
    </Box>
  );
};

export default Download;